// extracted by mini-css-extract-plugin
export default {"button":"register_button__lwcAv","container":"register_container__hfUX9","title":"register_title__9QvIF","form":"register_form__xaimI","card":"register_card__PfIms"};